import React from 'react';

import { AddDealProvider } from 'src/contexts/addDealContext';

import './AddDeal.scss';
import { AddDealBreadcrumb } from './AddDealBreadcrumb';
import { AddDealFooter } from './AddDealFooter';
import { ConfirmDeal } from './ConfirmDeal';
import { SelectVendor } from './SelectVendor';
import { SpecifyDeal } from './SpecifyDeal';

export const AddDeal = () => {
    const [step, setStep] = React.useState(1);

    const renderAddDealStep = () => {
        switch (step) {
            case 1:
                return <SelectVendor />;
            case 2:
                return <SpecifyDeal />;
            case 3:
                return <ConfirmDeal />;
            default:
                return <SelectVendor />;
        }
    };

    return (
        <div className="add-deal-div">
            <AddDealProvider>
                <AddDealBreadcrumb />
                {renderAddDealStep()}
                <AddDealFooter step={step} setStep={setStep} />
            </AddDealProvider>
        </div>
    );
};
